import React from "react";
import { Link, useLocation } from "react-router-dom";
import logo from "../asset/img/grahaksathi-logo.png";
import { BsFacebook } from "react-icons/bs";
import { FaYoutube } from "react-icons/fa";
import { GrInstagram } from "react-icons/gr";

const Footer = () => {
  const location = useLocation();

  return (
    <div>
      <div className=" pt-4 mt-8 pb-8 xl:pt-8">
        <footer className="bg-white">
          <div className="mx-auto w-full max-w-screen-xl">
            <div className="grid grid-cols-2 gap-8 px-4 py-6 lg:py-8 md:grid-cols-4">
              <div>
                <h2 className="mb-6 h-7">
                  {" "}
                  <img className="mb-3" src={logo} alt="logo" />{" "}
                </h2>
                <p className="text-gray-500 dark:text-gray-400 font-medium mt-3 py-2">
                  Start Your Business with Zero Investment and Earn over
                  ₹25000/- Every Month. Provide financial advice and products to
                  the customers and get a fast payout every month.
                </p>
              </div>
              <div>
                <h2 className="mb-6 text-sm font-semibold text-gray-900 uppercase dark:text-white">
                  Quick Links
                </h2>
                <ul className="text-gray-500 dark:text-gray-400 font-medium">
                  <li className="mb-4">
                    <Link to="/" className="hover:underline">
                      Home
                    </Link>
                  </li>
                  <li className="mb-4">
                    <Link to="/about" className="hover:underline">
                      About
                    </Link>
                  </li>
                  <li className="mb-4">
                    <Link to="/signup" className="hover:underline">
                      Sign Up
                    </Link>
                  </li>
                  <li className="mb-4">
                    <Link to="/login" className="hover:underline">
                      Login
                    </Link>
                  </li>
                </ul>
              </div>
              <div>
                <h2 className="mb-6 text-sm font-semibold text-gray-900 uppercase dark:text-white">
                  Our Services
                </h2>
                <ul className="text-gray-500 dark:text-gray-400 font-medium">
                  <li className="mb-4">
                    <Link
                      to="/bank_account_opening"
                      className="hover:underline"
                    >
                      Bank Account Opening
                    </Link>
                  </li>
                  <li className="mb-4">
                    <Link to="/demat_account" className="hover:underline">
                      Demat Account Opening
                    </Link>
                  </li>
                  <li className="mb-4">
                    <Link to="/small_loan" className="hover:underline">
                      Small Loan
                    </Link>
                  </li>
                  <li className="mb-4">
                    <Link to="/personal_loan" className="hover:underline">
                      Personal Loan
                    </Link>
                  </li>
                </ul>
              </div>
              <div>
                <h2 className="mb-6 text-sm font-semibold text-gray-900 uppercase dark:text-white">
                  Contact Us
                </h2>

                <span className="block mt-2 text-gray-500 dark:text-gray-400 font-medium">
                  care@grahaksathi.in
                </span>

                <span className="block mt-2 text-gray-500 dark:text-gray-400 font-medium">
                  Kodigehalli Main Rd 3rd Main, 560036 Bengaluru, India
                </span>
              </div>
            </div>
            <div className="px-4 py-6 bg-gray-100 dark:bg-gray-700 md:flex md:items-center md:justify-between">
              <span className="text-sm text-gray-500 dark:text-gray-300 sm:text-center">
                © 2023 <Link to="/">Grahat Sathi</Link>. All Rights Reserved.
              </span>
              <div className="flex font-semibold">
                Developed By XSafar Technology(Contact Us <a href="https://www.facebook.com/xSafarTechnology" target="_blank" rel="noreferrer"><BsFacebook className="relative top-1 mx-1 cursor-pointer"/></a>)
              </div>
              <div className="md:flex md:space-x-6">

              <div className="flex mt-4 sm:justify-center md:mt-0">
                <a
                  href="https://www.facebook.com/grahaksathiind"
                  target="_blank"
                  rel="noreferrer"
                  className="text-gray-400 hover:text-gray-900 dark:hover:text-white"
                >
                  <BsFacebook />
                  
                </a>
              </div>
              <div className="flex mt-4 sm:justify-center md:mt-0">
                <a
                  href="https://www.youtube.com/channel/UCsBlcGkjug_XleT3r363Lbw"
                  target="_blank"
                  rel="noreferrer"
                  className="text-gray-400 hover:text-gray-900 dark:hover:text-white"
                >
                  <FaYoutube />
                 
                </a>
              </div>
              <div className="flex mt-4 sm:justify-center md:mt-0">
                <a
                  href="https://www.instagram.com/grahaksathiindia/"
                  target="_blank"
                  rel="noreferrer"
                  className="text-gray-400 hover:text-gray-900 dark:hover:text-white"
                >
                  <GrInstagram />
                 
                </a>
              </div>
              </div>
            </div>
          </div>
        </footer>
      </div>
    </div>
  );
};

export default Footer;
